import {
    Checkbox,
    Grid, IconButton,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@material-ui/core";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {useEffect, useMemo, useRef, useState} from "react";
import {client} from "../../dataProvider";
import {Button, Link, useNotify} from "react-admin";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {EmployeePhotoFromBase64} from "../../components/EmployeePhotoFromBase64";
import {FaSquare} from "react-icons/fa";

const useStyles = makeStyles({
    root: {
        "& input": {
            height: "30px",
        },
        "& th": {
            borderRight: "1px solid lightgray",
            backgroundColor: "#fddfdd",
            padding: "10px 4px",
            fontSize: "1.2em",
            textAlign: "center",
        },
        "& td": {
            borderRight: "1px solid lightgray",
            padding: "4px 4px",
            fontSize: "1.1em",
        },
        "& tr": {
            '&:nth-child(odd)': {
                backgroundColor: '#EAEAEA',
            },
            '&:nth-child(even)': {
                backgroundColor: '#FFFFFF' // fourth bg color
            },
            '&:hover': {
                backgroundColor: '#d1dfd1 !important' // fifth bg color
            }
        },
        //alternative row only firs column
        '& tr:nth-child(even) td:first-child': {
            backgroundColor: '#FFFFFF',
        },
        '& tr:nth-child(odd) td:first-child': {
            backgroundColor: '#EAEAEA',
        },
    },
    compactCell: {
        padding: 2,
    },
    compactWrapper: {
        borderRadius: 6,
        padding: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        boxSizing: "border-box",
        gap: 4,
    },
    compactHeader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "0.7rem",
        fontWeight: 600,
        marginBottom: 2,
    },
    compactList: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
    },
    compactEmployeeRow: {
        display: "flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 3px",
        borderRadius: 4,
        backgroundColor: "rgba(0,0,0,0.02)",
    },
    compactPhotoWrapper: {
        width: 24,
        height: 24,
        flexShrink: 0,
        overflow: "hidden",
        borderRadius: "50%",
    },
    compactText: {
        flex: 1,
        overflow: "hidden",
    },
    compactName: {
        fontSize: "0.85rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    compactSite: {
        fontSize: "0.65rem",
        color: "#555",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    compactType: {
        fontSize: "0.85rem",
        color: "#333",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    compactChecks: {
        display: "flex",
        gap: 2,
        alignItems: "center",
        justifyContent: "center",
    },
});

export const WorkPermitCalendar = (props: any) => {
    const classes = useStyles();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlStartDate = urlParams.get('urlStartDate') ? urlParams.get('startDate') : new Date().toISOString().substring(0, 10);
    const urlEndDate = urlParams.get('endDate') ? urlParams.get('endDate') : new Date().toISOString().substring(0, 10);
    const urlSite = urlParams.get('site') ? urlParams.get('site') : "";
    const urlDepartments = urlParams.get('departments') ? urlParams.get('departments') : "";

    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const [calendarData, setCalendarData] = useState<any>([]);
    const [calendarDays, setCalendarDays] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(urlStartDate);
    const [site, setSite] = useState<any>(urlSite);
    const [departments, setDepartments] = useState<any>(urlDepartments);
    const [endDate, setEndDate] = useState<any>(urlEndDate);
    const [months, setMonths] = useState<any>([]);
    const [sitesOptions, setSitesOptions] = useState<any>([]);
    const [departmentsOptions, setDepartmentsOptions] = useState<any>([]);
    const [tableHeight, setTableHeight] = useState<any>(150);

    const refSerarchBar = useRef(null)

    function reloadCalendar() {
        setLoading(true)
        client(`./workpermits/calendar/?departments=${departments}&site=${site}&start_date=${startDate}&end_date=${endDate}`, {
            method: "GET",
        })
            .then((response) => {
                if (response.error) {
                    notify(response.error, {type: "error"});
                    return
                } else {
                    let presence_empy = []
                    for (let p_e in response.calendar) {
                        presence_empy.push(response.calendar[p_e])
                    }
                    presence_empy.sort(((a, b) => a.surname.localeCompare(b.surname)))
                    setCalendarData(presence_empy)
                    setCalendarDays(response.days)
                    setLoading(false)
                }

            })
            .catch((e: any) => {
                notify("Errore", {type: "error"});
            })
            .finally(() => {
                setLoading(false)
            });
    }

    useMemo(() => {
        reloadCalendar()
    }, [])


    useEffect(() => {
        if (refSerarchBar !== null && refSerarchBar.current !== null && refSerarchBar!.current!['clientHeight'] !== null)
            try {
                setTableHeight(refSerarchBar!.current!['clientHeight'] + 50)
            } catch (e) {
            }
    }, [
        refSerarchBar.current
    ])

    useEffect(() => {
        if (months.length > 0) {
            const date = new Date();
            const startMonth = String(months[0]).padStart(2, '0');
            let newEndDate;
            if (months[months.length - 1] !== 12) {
                const endMonth = String(months[months.length - 1] + 1).padStart(2, '0');
                newEndDate = new Date(`${date.getFullYear()}-${endMonth}-01`);
                newEndDate.setDate(newEndDate.getDate() - 1)
            } else {
                newEndDate = new Date(`${date.getFullYear()}-12-31`);
            }
            let newStartDate = new Date(`${date.getFullYear()}-${startMonth}-01`);
            setStartDate(newStartDate.toISOString().substring(0, 10))
            setEndDate(newEndDate.toISOString().substring(0, 10))
        }

    }, [months])

    useMemo(() => {
        setLoading(true)
        client(`./sites`, {
            method: "GET",
        })
            .then((response) => {
                if (response.error) {
                    notify(response.error, {type: "error"});
                    return
                } else {
                    let sites = []
                    for (let s in response.results) {
                        sites.push({
                            id: response.results[s].id,
                            label: response.results[s].business_name
                        })
                    }
                    sites.sort(((a, b) => a.label.localeCompare(b.label)))
                    setSitesOptions(sites)
                    setLoading(false)
                }

            })
            .catch((e: any) => {
                notify("Errore", {type: "error"});
            })
            .finally(() => {
                setLoading(false)
            });
    }, [])

    useMemo(() => {
        setLoading(true)
        client(`./departments`, {
            method: "GET",
        })
            .then((response) => {
                if (response.error) {
                    notify(response.error, {type: "error"});
                    return
                } else {
                    let departments = []
                    for (let s in response.results) {
                        departments.push({
                            id: response.results[s].pk,
                            label: response.results[s].description
                        })
                    }
                    departments.sort(((a, b) => a.label.localeCompare(b.label)))
                    setDepartmentsOptions(departments)
                    setLoading(false)
                }

            })
            .catch((e: any) => {
                notify("Errore", {type: "error"});
            })
            .finally(() => {
                setLoading(false)
            });
    }, [])


    function formatDate(date: any) {
        let d = new Date(date)
        return d.toLocaleString('it-IT', {'weekday': 'short', 'month': '2-digit', 'day': '2-digit'}).toUpperCase()
    }


    function getColorCheck(check: any) {
        if (check === "W") {
            return "grey"
        } else if (check === "A") {
            return "green"
        } else {
            return "red"
        }
    }

    const roles = useMemo(() => {
        const set = new Set<string>();

        calendarData.forEach((emp: any) => {
            const role = emp.departments || "N/D";
            set.add(role);
        });

        return Array.from(set).sort((a, b) => a.localeCompare(b));
    }, [calendarData]);


    const permitTypesByRole = useMemo(() => {
        const map: { [role: string]: string[] } = {};

        calendarData.forEach((emp: any) => {
            const role = emp.departments || "N/D";
            if (!map[role]) {
                map[role] = [];
            }

            emp.work_permits.forEach((wp: any) => {
                if (!wp || !wp.id) return;
                const type = wp.type;
                if (!map[role].includes(type)) {
                    map[role].push(type);
                }
            });
        });
        Object.keys(map).forEach((role) => {
            map[role].sort((a, b) => a.localeCompare(b));
        });

        return map;
    }, [calendarData]);


    const roleDayMap = useMemo(() => {
        const map: {
            [role: string]: {
                [type: string]: {
                    [day: string]: {
                        count: number;
                        employees: any[];
                        id: number;
                    };
                };
            };
        } = {};

        calendarData.forEach((emp: any) => {
            const role = emp.departments || "N/D";

            emp.work_permits.forEach((wp: any, idx: number) => {
                if (!wp || !wp.id) return;

                const type = wp.type;
                const day = calendarDays[idx];
                if (!day) return;

                if (!map[role]) {
                    map[role] = {};
                }
                if (!map[role][type]) {
                    map[role][type] = {};
                }
                if (!map[role][type][day]) {
                    map[role][type][day] = {
                        count: 0,
                        employees: [],
                        id: wp.id,
                    };
                }

                map[role][type][day].count += 1;

                map[role][type][day].employees.push({
                    employee_id: emp.id,
                    name: emp.name,
                    surname: emp.surname,
                    photo_base64: emp.photo_base64,
                    site: emp.site,
                    departments: emp.departments,
                    work_permit_id: wp.id,
                    date_in: wp.date_in,
                    date_out: wp.date_out,
                    check_1: wp.check_1,
                    check_2: wp.check_2,
                    check_3: wp.check_3,
                    type: wp.type,
                    id: wp.id,
                    minutes: wp.minutes,
                    type_permit: wp.type_permit,
                });
            });
        });

        return map;
    }, [calendarData, calendarDays]);

    return (
        <>
            <div style={{
                display: (loading) ? "block" : "none",
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                zIndex: 999,
            }}>
                <Typography style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "2em",
                }}>
                    Loading...
                </Typography>
            </div>
            <div onKeyDown={(e) => {
                if (e.key === "Enter") {
                    reloadCalendar()
                }
            }}>

                <Grid container
                      ref={refSerarchBar}
                      style={{
                          padding: "10px",
                          marginRight: "30px",
                          width: "100%"
                      }}>
                    <TextField
                        style={
                            {
                                width: "250px",
                                marginRight: "10px"
                            }
                        }
                        className={classes.root}

                        id="start_date"
                        label="Da"
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={startDate}
                        onChange={(e) => {
                            setStartDate(e.target.value)
                        }}
                    />
                    <TextField
                        style={
                            {
                                width: "250px",
                                marginRight: "10px"
                            }
                        }
                        className={classes.root}
                        id="end_date"
                        label="A"
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={endDate}
                        onChange={(e) => {
                            setEndDate(e.target.value)
                        }}
                    />
                    <Autocomplete
                        style={
                            {
                                width: "300px",
                                marginRight: "10px"
                            }
                        }
                        multiple
                        id="months"
                        options={[
                            {id: 1, label: 'Gennaio'},
                            {id: 2, label: 'Febbraio'},
                            {id: 3, label: 'Marzo'},
                            {id: 4, label: 'Aprile'},
                            {id: 5, label: 'Maggio'},
                            {id: 6, label: 'Giugno'},
                            {id: 7, label: 'Luglio'},
                            {id: 8, label: 'Agosto'},
                            {id: 9, label: 'Settembre'},
                            {id: 10, label: 'Ottobre'},
                            {id: 11, label: 'Novembre'},
                            {id: 12, label: 'Dicembre'},
                        ]}
                        getOptionLabel={(option: any) => option.label}
                        filterSelectedOptions
                        onChange={(event: any, newValue: any) => {
                            let tempMonths = []
                            for (let e in newValue) {
                                tempMonths.push(newValue[e].id)
                            }
                            tempMonths.sort(function (a, b) {
                                return a - b
                            })
                            setMonths(tempMonths)
                        }}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Seleziona mesi"
                            />
                        )}
                    />

                    {
                        sitesOptions && <Autocomplete
                            style={
                                {
                                    width: "300px",
                                    marginRight: "10px"
                                }
                            }
                            id="site"
                            options={sitesOptions}
                            getOptionLabel={(option: any) => option.label}
                            filterSelectedOptions
                            onChange={(event: any, newValue: any) => {
                                if (newValue)
                                    setSite(newValue.id)
                                else
                                    setSite("")
                            }}

                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Seleziona sede"
                                />
                            )}
                        />
                    }

                    {
                        departmentsOptions && <Autocomplete
                            style={
                                {
                                    width: "300px",
                                    marginRight: "10px"
                                }
                            }
                            multiple
                            id="departments"
                            options={departmentsOptions}
                            getOptionLabel={(option: any) => option.label}
                            filterSelectedOptions
                            onChange={(event: any, newValue: any) => {
                                let tempDepartments = []
                                for (let e in newValue) {
                                    tempDepartments.push(newValue[e].id)
                                }
                                tempDepartments.sort(function (a, b) {
                                    return a - b
                                })
                                setDepartments(tempDepartments)
                            }}

                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Seleziona reparti"
                                />
                            )}
                        />
                    }

                    <Button
                        style={
                            {
                                height: "55px",
                                width: "100px",
                                marginRight: "10px"
                            }
                        }
                        onClick={() => {
                            reloadCalendar()
                        }}
                        label=""
                        color="primary"
                        variant="contained"
                    >
                        <Typography>Filtra</Typography>
                    </Button>
                </Grid>


                <div style={{
                    position: "relative",
                    overflowX: "scroll",
                    overflowY: "scroll",
                    height: "calc(100vh - " + tableHeight + "px)",
                    width: "100%",
                }}>
                    <Table className={classes.root}>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        position: "sticky",
                                        left: 0,
                                        top: 0,
                                        boxShadow: "1px 1px 1px grey",
                                        borderRight: "1px solid black",
                                        zIndex: 100,
                                        width: "35px",
                                        backgroundColor: "#fddfdd",
                                        textAlign: "center",
                                    }}
                                    rowSpan={2}
                                >
                                    Giorno
                                </TableCell>

                                {roles.map((role: string) => (
                                    <TableCell
                                        key={role}
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            boxShadow: "1px 1px 1px grey",
                                            borderRight: "1px solid black",
                                            zIndex: 99,
                                            textAlign: "center",
                                        }}
                                        colSpan={permitTypesByRole[role]?.length || 1}
                                    >
                                        {role}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {roles.map((role: string) => {
                                    const types = permitTypesByRole[role] || ["Tutti"];
                                    return types.map((type) => (
                                        <TableCell
                                            key={`${role}-${type}`}
                                            style={{
                                                position: "sticky",
                                                top: 44,
                                                boxShadow: "1px 1px 1px grey",
                                                borderRight: "1px solid black",
                                                zIndex: 99,
                                                textAlign: "center",
                                                backgroundColor: "#ffeceb",
                                                fontSize: "0.8em",
                                            }}
                                        >
                                            {type}
                                        </TableCell>
                                    ));
                                })}
                            </TableRow>
                        </TableHead>


                        <TableBody>
                            {calendarDays.map((day: string) => (
                                <TableRow key={day}>
                                    <TableCell

                                        className={classes.compactCell}
                                    >
                                        {formatDate(Date.parse(day))}
                                    </TableCell>

                                    {roles.map((role: string) => {
                                        const types = permitTypesByRole[role] || ["Tutti"];

                                        return types.map((type) => {
                                            const cell = roleDayMap[role]?.[type]?.[day];

                                            if (!cell) {
                                                return (
                                                    <TableCell
                                                        key={`${day}-${role}-${type}`}
                                                        className={classes.compactCell}
                                                    />
                                                );
                                            }

                                            return (
                                                <TableCell
                                                    key={`${day}-${role}-${type}`}
                                                    className={classes.compactCell}
                                                    style={{textAlign: "center"}}
                                                >
                                                    <Link to={`./workpermits/${cell.id}`} target="_blank">
                                                        <div className={classes.compactWrapper}>
                                                            <div className={classes.compactHeader}>
                                                                <Typography variant="body2">
                                                                    {cell.employees.length} operator
                                                                    {cell.employees.length > 1 ? "i" : "e"}
                                                                </Typography>
                                                            </div>

                                                            <div className={classes.compactList}>
                                                                {cell.employees.map((e: any) => (
                                                                    <div
                                                                        key={e.work_permit_id}
                                                                        className={classes.compactEmployeeRow}
                                                                    >
                                                                        <EmployeePhotoFromBase64
                                                                            base64img={e.photo_base64}
                                                                            checkCondition={e}
                                                                        />
                                                                        <div className={classes.compactText}>
                                                                            <div className={classes.compactName}>
                                                                                {e.surname} {e.name}{" "}
                                                                                {e.site && (
                                                                                    <span
                                                                                        className={classes.compactSite}>
                                                                ({e.site})
                                                            </span>
                                                                                )}
                                                                            </div>
                                                                            <div className={classes.compactType}>{e.type_permit === "D"
                                                                                    ? `(${e.date_in} – ${e.date_out})`
                                                                                    : `${e.minutes / 60} ore`}
                                                                            </div>
                                                                            <div className={classes.compactChecks}>
                                                                                <FaSquare
                                                                                    color={getColorCheck(e.check_1)}
                                                                                    size={17}
                                                                                    title="Check 1"
                                                                                />
                                                                                <FaSquare
                                                                                    color={getColorCheck(e.check_2)}
                                                                                    size={17}
                                                                                    title="Check 2"
                                                                                />
                                                                                <FaSquare
                                                                                    color={getColorCheck(e.check_3)}
                                                                                    size={17}
                                                                                    title="Check 3"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </TableCell>
                                            );
                                        });
                                    })}
                                </TableRow>
                            ))}
                            <TableRow style={{
                                height: "1000px",
                            }}>
                            </TableRow>
                        </TableBody>

                    </Table>
                </div>
            </div>
        </>
    );
};
